import { FC, useState } from 'react';

import { useSetRecoilState } from 'recoil';

import { Icon } from '@shared/components/icons';

import { searchTextAtomFamily } from './state/searchBar.atom';

interface IProps {
  searchTextAtomId: string;
  placeholder?: string;
  onSearch?: () => void;
}

const SearchBar: FC<IProps> = ({
  searchTextAtomId,
  placeholder,
  onSearch: onSearchRequest,
}: IProps) => {
  const { MagnifyingGlassRegular } = Icon();
  const setSearchText = useSetRecoilState(searchTextAtomFamily(searchTextAtomId));
  const [inputValue, setInputValue] = useState('');

  const onTextChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setInputValue(event.currentTarget.value);

  const onSearch = () => {
    setSearchText(inputValue);
    onSearchRequest?.();
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSearch();
    }
  };

  return (
    <div className="relative flex w-full items-center space-x-2 border px-4 theme-bg-1 theme-border-1 focus:theme-border-main">
      <input
        type="text"
        placeholder={placeholder}
        className="w-full py-3 text-sm font-bold theme-text-1 placeholder:theme-text-6"
        value={inputValue}
        onChange={onTextChange}
        onKeyDown={onKeyDown}
      />
      <button type="button" onClick={onSearch} className="shrink-0" aria-label="검색">
        <MagnifyingGlassRegular className="wh-5 theme-fill-2" />
      </button>
    </div>
  );
};

export default SearchBar;
